import React, { createContext, useContext, useState, useEffect } from "react";

const TRANSLATIONS = {
  el: {
    nav: {
      collections: "Συλλογές",
      gallery: "Gallery",
      story: "Ιστορία",
      contact: "Επικοινωνία",
      order: "Παραγγελία",
    },
    hero: {
      tagline: "The Pure Essence of Greece",
      sub: "Greek Treasure",
      desc: "Premium gifting experiences crafted for unforgettable moments — for hotels, villas, weddings and VIP clients.",
      cta: "Explore Collections",
      ctaContact: "Corporate Gifting",
      scroll: "SCROLL",
    },
    products: {
      eyebrow: "Συλλογές",
      title: "Τρεις Συλλογές. Μία Ψυχή.",
      sub: "Από το διακριτικό essentials καλάθι μέχρι το ολοκληρωμένο luxury experience — διαλέξτε το δώρο που ταιριάζει στην περίσταση.",
      low: {
        badge: "Essentials",
        name: "Essentials Καλάθι",
        desc: "Παραδοσιακό καλάθι με τα τρία κλασικά: λάδι, μέλι, σαπούνι. Διακριτικό, αυθεντικό δώρο.",
        items: [
          "Extra Virgin Ελαιόλαδο 250ml",
          "Θυμαρίσιο Μέλι 200g",
          "Σαπούνι Ελαιόλαδου",
        ],
        accent: "Μια γεύση Ελλάδας σε λιτή μορφή.",
      },
      mid: {
        badge: "Heritage",
        name: "Heritage Κουτί",
        desc: "Μεσαίο πολυτελές κουτί με πέντε προσεκτικά επιλεγμένα προϊόντα — ιδανικό για ξενοδοχεία και ευχαριστίες.",
        items: [
          "Extra Virgin Ελαιόλαδο 500ml",
          "Θυμαρίσιο Μέλι 380g",
          "Παραδοσιακό Τσίπουρο 200ml",
          "Ελιές Καλαμών 200g",
          "Σαπούνι Ελαιόλαδου",
        ],
        accent: "Η ψυχή της Μεσογείου σε κάθε γεύση.",
      },
      premium: {
        badge: "Premium",
        name: "Premium Gift Box",
        desc: "Πολυτελές μαύρο κουτί δώρου με χρυσή κορδέλα. Έξι εκλεκτά ελληνικά προϊόντα.",
        items: [
          "Extra Virgin Ελαιόλαδο 750ml",
          "Santorini Assyrtiko 2022 — 750ml",
          "Θυμαρίσιο Μέλι 380g",
          "Ρακόμελο 750ml",
          "Τσίπουρο 750ml",
          "Σαπούνι Ελαιόλαδου",
        ],
        accent: "Η πιο ολοκληρωμένη εμπειρία της Ελλάδας σε ένα κουτί.",
      },
      orderBtn: "Παραγγελία",
    },
    cretan: {
      eyebrow: "Κρητική Κουλτούρα",
      title: "Από τα χώματα της Κρήτης\nστο τραπέζι σας.",
      sub: "Η ψυχή της Μεσογείου σε εκλεκτά αυθεντικά προϊόντα — επιλεγμένα ένα-ένα από τοπικούς παραγωγούς.",
      inquire: "Ζητήστε προσφορά",
      view: "Δείτε προϊόντα",
      contents: "Περιεχόμενα",
      note: "Διαθέσιμα μεμονωμένα ή σε εξατομικευμένα καλάθια. Επικοινωνήστε για ποσότητες και τιμές.",
      dialogNote: "Για ποσότητες, τιμές και ειδικές παραγγελίες, επικοινωνήστε μαζί μας μέσω WhatsApp ή τηλεφώνου.",
      tiers: {
        small: "Μικρό",
        medium: "Μεσαίο",
        premium: "Premium",
      },
      whatsappMsg: "Γεια σας! Με ενδιαφέρει η κατηγορία \"{category}\". Θα ήθελα περισσότερες πληροφορίες.",
      cats: {
        giftbox: { name: "Δωροπακέτα", desc: "Πολυτελή καλάθια δώρου σε 3 επίπεδα — από essentials μέχρι premium." },
        oil: { name: "Ελαιόλαδο", desc: "Extra Virgin από Κρήτη & Πελοπόννησο. Ψυχρή έκθλιψη, χαμηλή οξύτητα." },
        olives: { name: "Ελιές", desc: "Καλαμών, Θρούμπες, πράσινες Χαλκιδικής σε άλμη ή ελαιόλαδο." },
        honey: { name: "Μέλι", desc: "Θυμαρίσιο, ανθέων, πεύκου — από μικρούς μελισσοκόμους της κρητικής φύσης." },
        raki: { name: "Ρακή / Τσικουδιά", desc: "Παραδοσιακή κρητική τσικουδιά, αποσταγμένη με σεβασμό στην παράδοση." },
        wine: { name: "Κρασί", desc: "Ασύρτικο Σαντορίνης, Βιδιανό Κρήτης, Λιάτικο — εκλεκτές ετικέτες." },
        vinegar: { name: "Ξύδι", desc: "Παλαιωμένο balsamic, μηλόξυδο και ξύδι κρασιού από επιλεγμένους αμπελώνες." },
        rusks: { name: "Παξιμάδι", desc: "Κρητικά κρίθινα παξιμάδια, ιδανικά για ντάκο με ντομάτα και ελαιόλαδο." },
        herbs: { name: "Μπαχαρικά", desc: "Ρίγανη, θυμάρι, φασκόμηλο, αλάτι Μεσσηνίας — άρωμα Ελλάδας." },
        recipes: { name: "Βιβλίο Συνταγών", desc: "Αυθεντικές κρητικές συνταγές από χωριά που δύσκολα θα βρεις." },
      },
    },
    about: {
      eyebrow: "Η Ιστορία μας",
      title: "Γεννημένο\nστην Κρήτη.",
      p1: "Το Golden Elia γεννήθηκε και ιδρύθηκε στην Κρήτη — εκεί όπου η ελιά, το σταφύλι και ο ήλιος συναντιούνται εδώ και χιλιάδες χρόνια.",
      p2: "Όλα παράγονται εδώ. Δεν είναι μάρκετινγκ. Είναι αγάπη για τα ελληνικά προϊόντα και βαθύς σεβασμός στους ανθρώπους που, με ακούραστους κόπους, διατηρούν ζωντανές παραδόσεις γενεών. Συνεργαζόμαστε αποκλειστικά με μικρές οικογένειες παραγωγών από απομονωμένα κρητικά χωριά — άντρες και γυναίκες που γνωρίζουν κάθε δέντρο, κάθε αμπέλι, κάθε σταγόνα μελιού με το όνομά της.",
      p3: "Αυτές οι πηγές δεν υπάρχουν πουθενά αλλού. Δεν αγοράζονται. Κερδίζονται με χρόνο, εμπιστοσύνη και φιλία. Γι' αυτό κάθε μπουκάλι Golden Elia είναι το πιο premium που μπορεί να βρει κανείς αυτή τη στιγμή στην αγορά — ένα κομμάτι Κρήτης, ένα κομμάτι Ελλάδας, ένα κομμάτι ψυχής.",
      signEyebrow: "Από την οικογένεια Golden Elia",
      signature: "— Κρήτη, με αγάπη.",
      videos: {
        oilEyebrow: "Παραγωγή",
        oilTitle: "Έτσι γεννιέται το λάδι.",
        wineEyebrow: "Παραγωγή",
        wineTitle: "Έτσι γεννιέται το κρασί.",
      },
    },
    contact: {
      eyebrow: "Επικοινωνία",
      title: "Είμαστε εδώ για εσάς",
      sub: "Για παραγγελίες, εξατομικευμένα δώρα ή χονδρική, καλέστε μας ή στείλτε μήνυμα στο WhatsApp.",
      whatsapp: "Στείλτε WhatsApp",
      call: "Κλήση τώρα",
      owner: "Ιδιοκτήτης: Αστροπαλίτης Γιώργος",
      whatsappMsg: "Γεια σας! Θα ήθελα πληροφορίες για τα προϊόντα Golden Elia.",
    },
    order: {
      title: "Παραγγελία",
      thanks: "Σας ευχαριστούμε!",
      subDone: "Θα επικοινωνήσουμε άμεσα μαζί σας για επιβεβαίωση.",
      orderNo: "Παραγγελία",
      total: "Σύνολο",
      close: "Κλείσιμο",
      submit: "Επιβεβαίωση",
      sending: "Αποστολή...",
      isGift: "Είναι δώρο για κάποιον",
      giftHelp: "Θα τυπώσουμε όνομα παραλήπτη και προσωπικό μήνυμα σε χρυσή κάρτα μέσα στο κουτί.",
      fields: {
        name: "Ονοματεπώνυμο*",
        phone: "Τηλέφωνο*",
        email: "Email",
        address: "Διεύθυνση*",
        city: "Πόλη*",
        postal: "Τ.Κ.",
        quantity: "Ποσότητα",
        notes: "Σημειώσεις",
        recipient: "Όνομα παραλήπτη",
        giftMsg: "Προσωπικό μήνυμα στην κάρτα",
      },
      errors: {
        required: "Συμπληρώστε όλα τα υποχρεωτικά πεδία.",
        generic: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
      },
      success: "Η παραγγελία σας καταχωρήθηκε!",
    },
    footer: "Όλα τα δικαιώματα διατηρούνται.",
    cart: {
      title: "Καλάθι",
      emptyTitle: "Το καλάθι σας είναι άδειο",
      emptyHint: "Εξερευνήστε τις συλλογές μας και προσθέστε αυθεντικά ελληνικά προϊόντα.",
      addToCart: "Προσθήκη",
      addedToCart: "Προστέθηκε στο καλάθι",
      buyNow: "Αγορά τώρα",
      viewCart: "Δείτε καλάθι",
      continueShopping: "Συνεχίστε τα ψώνια",
      subtotal: "Σύνολο",
      checkout: "Ολοκλήρωση",
      checkoutTitle: "Στοιχεία Παραλαβής",
      checkoutSub: "Θα επικοινωνήσουμε άμεσα για επιβεβαίωση και αντικαταβολή / πληρωμή.",
      backToCart: "Επιστροφή",
      checkoutSuccess: "Η παραγγελία σας καταχωρήθηκε.",
      almostThere: "Σχεδόν εκεί",
      toGo: "ακόμα",
      unlock80: "Παραγγελίες ≥ €80 παίρνουν ένα μπουκάλι δώρο.",
      giftEyebrow: "Δώρο της Golden Elia",
      giftTitle: "Επιλέξτε το δώρο σας — ένα μπουκάλι, χωρίς χρέωση.",
      giftIncluded: "Δώρο",
    },
  },

  en: {
    nav: { collections: "Collections", gallery: "Gallery", story: "Story", contact: "Contact", order: "Order" },
    hero: {
      tagline: "The Pure Essence of Greece",
      sub: "Greek Treasure",
      desc: "Handcrafted gifts from the Greek land — premium olive oil, wine, honey and spirits, packaged with love for the ones you cherish.",
      cta: "View Collections",
      ctaContact: "Contact",
      scroll: "SCROLL",
    },
    products: {
      eyebrow: "Collections",
      title: "Three Collections. One Soul.",
      sub: "From an understated essentials basket to a complete luxury experience — choose the gift that fits the moment.",
      low: {
        badge: "Essentials",
        name: "Essentials Basket",
        desc: "Traditional basket with the three classics: olive oil, honey, soap. An understated, authentic gift.",
        items: [
          "Extra Virgin Olive Oil 250ml",
          "Thyme Honey 200g",
          "Olive Oil Soap",
        ],
        accent: "A taste of Greece in its purest form.",
      },
      mid: {
        badge: "Heritage",
        name: "Heritage Box",
        desc: "Mid-tier luxury box with five carefully selected products — ideal for hotels and corporate gifting.",
        items: [
          "Extra Virgin Olive Oil 500ml",
          "Thyme Honey 380g",
          "Traditional Tsipouro 200ml",
          "Kalamata Olives 200g",
          "Olive Oil Soap",
        ],
        accent: "The soul of the Mediterranean in every flavour.",
      },
      premium: {
        badge: "Premium",
        name: "Premium Gift Box",
        desc: "Luxurious black gift box with gold ribbon. A curated set of six exquisite Greek products.",
        items: [
          "Extra Virgin Olive Oil 750ml",
          "Santorini Assyrtiko 2022 — 750ml",
          "Thyme Honey 380g",
          "Rakomelo 750ml",
          "Tsipouro 750ml",
          "Olive Oil Soap",
        ],
        accent: "The most complete Greek experience in a single box.",
      },
      orderBtn: "Order",
    },
    cretan: {
      eyebrow: "Cretan Heritage",
      title: "From the soil of Crete\nto your table.",
      sub: "The soul of the Mediterranean in select authentic products — chosen one by one from local producers.",
      inquire: "Request a quote",
      view: "View products",
      contents: "Contents",
      note: "Available individually or as bespoke baskets. Contact us for quantities and pricing.",
      dialogNote: "For quantities, pricing and custom orders, contact us via WhatsApp or phone.",
      tiers: {
        small: "Small",
        medium: "Medium",
        premium: "Premium",
      },
      whatsappMsg: "Hello! I'm interested in the \"{category}\" category. I'd like more information.",
      cats: {
        giftbox: { name: "Gift Boxes", desc: "Luxury gift baskets in 3 tiers — from essentials to premium." },
        oil: { name: "Olive Oil", desc: "Extra Virgin from Crete & Peloponnese. Cold-pressed, low acidity." },
        olives: { name: "Olives", desc: "Kalamata, Throumba, green Chalkidiki in brine or olive oil." },
        honey: { name: "Honey", desc: "Thyme, wildflower, pine — from small beekeepers of Cretan nature." },
        raki: { name: "Raki / Tsikoudia", desc: "Traditional Cretan tsikoudia, distilled with respect for tradition." },
        wine: { name: "Wine", desc: "Santorini Assyrtiko, Cretan Vidiano, Liatiko — select labels." },
        vinegar: { name: "Vinegar", desc: "Aged balsamic, apple cider and wine vinegar from select vineyards." },
        rusks: { name: "Rusks", desc: "Cretan barley rusks, ideal for dakos with tomato and olive oil." },
        herbs: { name: "Herbs & Spices", desc: "Oregano, thyme, sage, Messinian salt — the aroma of Greece." },
        recipes: { name: "Recipe Book", desc: "Authentic Cretan recipes from hidden mountain villages — family secrets." },
      },
    },
    about: {
      eyebrow: "Our Story",
      title: "Born\nin Crete.",
      p1: "Golden Elia was born and founded in Crete — where the olive tree, the vine and the sun have been meeting for thousands of years.",
      p2: "Everything is made here. This is not marketing. It is love for Greek products and deep respect for the people who, through tireless labour, keep generational traditions alive. We work exclusively with small producer families from remote Cretan villages — men and women who know every tree, every vine, every drop of honey by its name.",
      p3: "These sources do not exist anywhere else. They cannot be bought. They are earned through time, trust and friendship. That is why every bottle of Golden Elia is the most premium one can find on the market right now — a piece of Crete, a piece of Greece, a piece of soul.",
      signEyebrow: "From the Golden Elia family",
      signature: "— Crete, with love.",
      videos: {
        oilEyebrow: "Production",
        oilTitle: "How the oil is born.",
        wineEyebrow: "Production",
        wineTitle: "How the wine is born.",
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "We're here for you",
      sub: "For orders, custom gifts or wholesale, call us or message us on WhatsApp.",
      whatsapp: "Send WhatsApp",
      call: "Call now",
      owner: "Owner: Astropalitis Giorgos",
      whatsappMsg: "Hello! I'd like more information about Golden Elia products.",
    },
    order: {
      title: "Order",
      thanks: "Thank you!",
      subDone: "We will contact you shortly to confirm.",
      orderNo: "Order",
      total: "Total",
      close: "Close",
      submit: "Confirm",
      sending: "Sending...",
      isGift: "This is a gift for someone",
      giftHelp: "We'll print the recipient's name and your message on a gold card inside the box.",
      fields: {
        name: "Full Name*",
        phone: "Phone*",
        email: "Email",
        address: "Address*",
        city: "City*",
        postal: "Postal Code",
        quantity: "Quantity",
        notes: "Notes",
        recipient: "Recipient name",
        giftMsg: "Personal card message",
      },
      errors: {
        required: "Please fill in all required fields.",
        generic: "Something went wrong. Please try again.",
      },
      success: "Your order has been placed!",
    },
    footer: "All rights reserved.",
    cart: {
      title: "Cart",
      emptyTitle: "Your cart is empty",
      emptyHint: "Explore our collections and add authentic Greek products.",
      addToCart: "Add to cart",
      addedToCart: "Added to cart",
      buyNow: "Buy now",
      viewCart: "View cart",
      continueShopping: "Continue shopping",
      subtotal: "Subtotal",
      checkout: "Checkout",
      checkoutTitle: "Shipping Details",
      checkoutSub: "We'll contact you shortly to confirm and arrange COD / payment.",
      backToCart: "Back",
      checkoutSuccess: "Your order has been placed.",
      almostThere: "Almost there",
      toGo: "to go",
      unlock80: "Orders over €80 receive a complimentary bottle.",
      giftEyebrow: "Golden Elia Gift",
      giftTitle: "Choose your complimentary bottle — on the house.",
      giftIncluded: "Gift",
    },
  },

  bg: {
    nav: { collections: "Колекции", gallery: "Галерия", story: "История", contact: "Контакт", order: "Поръчка" },
    hero: {
      tagline: "The Pure Essence of Greece",
      sub: "Greek Treasure",
      desc: "Ръчно изработени подаръци от гръцката земя — първокласен зехтин, вино, мед и спиртни напитки, опаковани с любов за вашите близки.",
      cta: "Вижте колекциите",
      ctaContact: "Контакт",
      scroll: "SCROLL",
    },
    products: {
      eyebrow: "Колекции",
      title: "Три колекции. Една душа.",
      sub: "От семпла essentials кошница до пълно luxury изживяване — изберете подаръка за повода.",
      low: {
        badge: "Essentials",
        name: "Essentials Кошница",
        desc: "Традиционна кошница с трите класики: зехтин, мед, сапун. Семпъл, автентичен подарък.",
        items: [
          "Extra Virgin Зехтин 250ml",
          "Мащерков мед 200g",
          "Сапун от зехтин",
        ],
        accent: "Вкусът на Гърция в най-чистата си форма.",
      },
      mid: {
        badge: "Heritage",
        name: "Heritage Кутия",
        desc: "Средна луксозна кутия с пет внимателно подбрани продукта — идеална за хотели и корпоративни подаръци.",
        items: [
          "Extra Virgin Зехтин 500ml",
          "Мащерков мед 380g",
          "Традиционно Ципуро 200ml",
          "Калмата маслини 200g",
          "Сапун от зехтин",
        ],
        accent: "Душата на Средиземноморието във всеки вкус.",
      },
      premium: {
        badge: "Premium",
        name: "Premium Подаръчна Кутия",
        desc: "Луксозна черна подаръчна кутия със златна панделка. Шест отбрани гръцки продукта.",
        items: [
          "Extra Virgin Зехтин 750ml",
          "Санторини Асиртико 2022 — 750ml",
          "Мащерков мед 380g",
          "Ракомело 750ml",
          "Ципуро 750ml",
          "Сапун от зехтин",
        ],
        accent: "Най-пълното гръцко изживяване в една кутия.",
      },
      orderBtn: "Поръчай",
    },
    cretan: {
      eyebrow: "Критско наследство",
      title: "От земята на Крит\nдо вашата маса.",
      sub: "Душата на Средиземноморието в подбрани автентични продукти — избрани един по един от местни производители.",
      inquire: "Запитване",
      view: "Виж продукти",
      contents: "Съдържание",
      note: "Налични поотделно или в персонализирани кошници. Свържете се за количества и цени.",
      dialogNote: "За количества, цени и индивидуални поръчки, свържете се с нас чрез WhatsApp или телефон.",
      tiers: {
        small: "Малък",
        medium: "Среден",
        premium: "Premium",
      },
      whatsappMsg: "Здравейте! Интересува ме категория \"{category}\". Бих искал повече информация.",
      cats: {
        giftbox: { name: "Подаръчни кутии", desc: "Луксозни кошници в 3 нива — от essentials до premium." },
        oil: { name: "Зехтин", desc: "Extra Virgin от Крит и Пелопонес. Студено пресован, ниска киселинност." },
        olives: { name: "Маслини", desc: "Калмата, Тромба, зелени халкидикски в саламура или зехтин." },
        honey: { name: "Мед", desc: "Мащерков, полски, борови — от малки пчелари на критската природа." },
        raki: { name: "Ракия / Цикудия", desc: "Традиционна критска цикудия, дестилирана с уважение към традицията." },
        wine: { name: "Вино", desc: "Санторини Асиртико, критско Видиано, Лиатико — селектирани етикети." },
        vinegar: { name: "Оцет", desc: "Отлежал балсамов, ябълков и винен оцет от селектирани лозя." },
        rusks: { name: "Сухар", desc: "Критски ечемичен сухар, идеален за дакос с домат и зехтин." },
        herbs: { name: "Подправки", desc: "Риган, мащерка, градински чай, месенска сол — ароматът на Гърция." },
        recipes: { name: "Книга с рецепти", desc: "Автентични критски рецепти от скрити планински села." },
      },
    },
    about: {
      eyebrow: "Нашата история",
      title: "Роден\nв Крит.",
      p1: "Golden Elia е роден и основан на остров Крит — там, където маслината, лозата и слънцето се срещат от хиляди години.",
      p2: "Всичко се произвежда тук. Това не е маркетинг. Това е любов към гръцките продукти и дълбоко уважение към хората, които с неуморен труд поддържат живи традициите на поколения. Работим изключително с малки семейства производители от отдалечени критски села — мъже и жени, които познават всяко дърво, всяка лоза, всяка капка мед по име.",
      p3: "Тези източници не съществуват никъде другаде. Те не могат да се купят. Те се печелят с време, доверие и приятелство. Затова всяка бутилка Golden Elia е най-премиум продуктът, който може да се намери на пазара в момента — част от Крит, част от Гърция, част от душа.",
      signEyebrow: "От семейството Golden Elia",
      signature: "— Крит, с любов.",
      videos: {
        oilEyebrow: "Производство",
        oilTitle: "Така се ражда зехтинът.",
        wineEyebrow: "Производство",
        wineTitle: "Така се ражда виното.",
      },
    },
    contact: {
      eyebrow: "Контакт",
      title: "Тук сме за вас",
      sub: "За поръчки, персонализирани подаръци или едро, обадете ни се или ни пишете в WhatsApp.",
      whatsapp: "Изпрати WhatsApp",
      call: "Обади се сега",
      owner: "Собственик: Астропалитис Георгиос",
      whatsappMsg: "Здравейте! Бих искал/а повече информация за продуктите Golden Elia.",
    },
    order: {
      title: "Поръчка",
      thanks: "Благодарим Ви!",
      subDone: "Ще се свържем с вас скоро за потвърждение.",
      orderNo: "Поръчка",
      total: "Общо",
      close: "Затвори",
      submit: "Потвърди",
      sending: "Изпращане...",
      isGift: "Това е подарък за някого",
      giftHelp: "Ще отпечатаме името на получателя и съобщението върху златна картичка в кутията.",
      fields: {
        name: "Име и фамилия*",
        phone: "Телефон*",
        email: "Email",
        address: "Адрес*",
        city: "Град*",
        postal: "Пощенски код",
        quantity: "Количество",
        notes: "Бележки",
        recipient: "Име на получателя",
        giftMsg: "Лично съобщение на картичката",
      },
      errors: {
        required: "Моля, попълнете всички задължителни полета.",
        generic: "Нещо се обърка. Опитайте отново.",
      },
      success: "Вашата поръчка е приета!",
    },
    footer: "Всички права запазени.",
    cart: {
      title: "Кошница",
      emptyTitle: "Кошницата ви е празна",
      emptyHint: "Разгледайте нашите колекции и добавете автентични гръцки продукти.",
      addToCart: "Добави",
      addedToCart: "Добавено в кошницата",
      buyNow: "Купи сега",
      viewCart: "Виж кошница",
      continueShopping: "Продължи пазаруването",
      subtotal: "Сума",
      checkout: "Поръчай",
      checkoutTitle: "Данни за доставка",
      checkoutSub: "Ще се свържем с вас за потвърждение и заплащане.",
      backToCart: "Назад",
      checkoutSuccess: "Поръчката ви е приета.",
      almostThere: "Почти стигнахте",
      toGo: "още",
      unlock80: "Поръчки над €80 получават бутилка подарък.",
      giftEyebrow: "Подарък от Golden Elia",
      giftTitle: "Изберете своя подарък — една бутилка безплатно.",
      giftIncluded: "Подарък",
    },
  },

  ru: {
    nav: { collections: "Коллекции", gallery: "Галерея", story: "История", contact: "Контакты", order: "Заказ" },
    hero: {
      tagline: "The Pure Essence of Greece",
      sub: "Greek Treasure",
      desc: "Подарки ручной работы из греческой земли — отборное оливковое масло, вино, мёд и напитки, упакованные с любовью для дорогих вам людей.",
      cta: "Посмотреть коллекции",
      ctaContact: "Контакты",
      scroll: "SCROLL",
    },
    products: {
      eyebrow: "Коллекции",
      title: "Три коллекции. Одна душа.",
      sub: "От лаконичной essentials корзины до полного luxury опыта — выберите подарок для случая.",
      low: {
        badge: "Essentials",
        name: "Essentials Корзина",
        desc: "Традиционная корзина с тремя классиками: масло, мёд, мыло. Лаконичный, аутентичный подарок.",
        items: [
          "Extra Virgin Оливковое масло 250мл",
          "Тимьяновый мёд 200г",
          "Мыло из оливкового масла",
        ],
        accent: "Вкус Греции в его чистейшей форме.",
      },
      mid: {
        badge: "Heritage",
        name: "Heritage Коробка",
        desc: "Средняя люксовая коробка с пятью тщательно подобранными продуктами — идеально для отелей и корпоративных подарков.",
        items: [
          "Extra Virgin Оливковое масло 500мл",
          "Тимьяновый мёд 380г",
          "Традиционный Ципуро 200мл",
          "Каламатские оливки 200г",
          "Мыло из оливкового масла",
        ],
        accent: "Душа Средиземноморья в каждом вкусе.",
      },
      premium: {
        badge: "Premium",
        name: "Premium Подарочный Набор",
        desc: "Роскошная чёрная подарочная коробка с золотой лентой. Шесть изысканных греческих продуктов.",
        items: [
          "Extra Virgin Оливковое масло 750мл",
          "Санторини Асиртико 2022 — 750мл",
          "Тимьяновый мёд 380г",
          "Ракомело 750мл",
          "Ципуро 750мл",
          "Мыло из оливкового масла",
        ],
        accent: "Самый полный греческий опыт в одной коробке.",
      },
      orderBtn: "Заказать",
    },
    cretan: {
      eyebrow: "Критское наследие",
      title: "От земли Крита\nна ваш стол.",
      sub: "Душа Средиземноморья в избранных аутентичных продуктах — выбранных по одному у местных производителей.",
      inquire: "Запросить предложение",
      view: "Смотреть продукты",
      contents: "Состав",
      note: "Доступно отдельно или в индивидуальных корзинах. Свяжитесь с нами для количеств и цен.",
      dialogNote: "Для количеств, цен и индивидуальных заказов свяжитесь с нами через WhatsApp или по телефону.",
      tiers: {
        small: "Малый",
        medium: "Средний",
        premium: "Premium",
      },
      whatsappMsg: "Здравствуйте! Меня интересует категория \"{category}\". Я бы хотел получить больше информации.",
      cats: {
        giftbox: { name: "Подарочные наборы", desc: "Роскошные корзины в 3 уровнях — от essentials до premium." },
        oil: { name: "Оливковое масло", desc: "Extra Virgin с Крита и Пелопоннеса. Холодный отжим, низкая кислотность." },
        olives: { name: "Оливки", desc: "Каламата, Тромба, зелёные халкидикские в рассоле или масле." },
        honey: { name: "Мёд", desc: "Тимьяновый, цветочный, сосновый — от мелких пчеловодов критской природы." },
        raki: { name: "Раки / Цикудия", desc: "Традиционная критская цикудия, дистиллированная с уважением к традиции." },
        wine: { name: "Вино", desc: "Санторини Асиртико, критское Видиано, Лиатико — отборные этикетки." },
        vinegar: { name: "Уксус", desc: "Выдержанный бальзамический, яблочный и винный уксус с отборных виноградников." },
        rusks: { name: "Сухарики", desc: "Критские ячменные сухари, идеальны для дакоса с томатами и маслом." },
        herbs: { name: "Специи", desc: "Орегано, тимьян, шалфей, мессинская соль — аромат Греции." },
        recipes: { name: "Книга рецептов", desc: "Аутентичные критские рецепты из скрытых горных деревень." },
      },
    },
    about: {
      eyebrow: "Наша История",
      title: "Рождён\nна Крите.",
      p1: "Golden Elia родился и был основан на острове Крит — там, где олива, виноградная лоза и солнце встречаются уже тысячи лет.",
      p2: "Всё производится здесь. Это не маркетинг. Это любовь к греческим продуктам и глубокое уважение к людям, которые неустанным трудом сохраняют живыми традиции поколений. Мы работаем исключительно с маленькими семьями производителей из удалённых критских деревень — мужчинами и женщинами, которые знают каждое дерево, каждую лозу, каждую каплю мёда по имени.",
      p3: "Этих источников не существует больше нигде. Их нельзя купить. Они зарабатываются временем, доверием и дружбой. Поэтому каждая бутылка Golden Elia — самый премиальный продукт, который можно найти на рынке сейчас. Кусочек Крита, кусочек Греции, кусочек души.",
      signEyebrow: "От семьи Golden Elia",
      signature: "— Крит, с любовью.",
      videos: {
        oilEyebrow: "Производство",
        oilTitle: "Так рождается масло.",
        wineEyebrow: "Производство",
        wineTitle: "Так рождается вино.",
      },
    },
    contact: {
      eyebrow: "Контакты",
      title: "Мы здесь для вас",
      sub: "Для заказов, персональных подарков или оптовых поставок — позвоните или напишите в WhatsApp.",
      whatsapp: "Написать в WhatsApp",
      call: "Позвонить",
      owner: "Владелец: Астропалитис Георгос",
      whatsappMsg: "Здравствуйте! Хотел(а) бы узнать больше о продукции Golden Elia.",
    },
    order: {
      title: "Заказ",
      thanks: "Спасибо!",
      subDone: "Мы свяжемся с вами в ближайшее время для подтверждения.",
      orderNo: "Заказ",
      total: "Итого",
      close: "Закрыть",
      submit: "Подтвердить",
      sending: "Отправка...",
      isGift: "Это подарок для кого-то",
      giftHelp: "Мы напечатаем имя получателя и ваше сообщение на золотой карточке внутри коробки.",
      fields: {
        name: "Имя и Фамилия*",
        phone: "Телефон*",
        email: "Email",
        address: "Адрес*",
        city: "Город*",
        postal: "Индекс",
        quantity: "Количество",
        notes: "Примечания",
        recipient: "Имя получателя",
        giftMsg: "Личное сообщение на карточке",
      },
      errors: {
        required: "Заполните все обязательные поля.",
        generic: "Что-то пошло не так. Попробуйте снова.",
      },
      success: "Ваш заказ принят!",
    },
    footer: "Все права защищены.",
    cart: {
      title: "Корзина",
      emptyTitle: "Ваша корзина пуста",
      emptyHint: "Откройте наши коллекции и добавьте аутентичные греческие продукты.",
      addToCart: "Добавить",
      addedToCart: "Добавлено в корзину",
      buyNow: "Купить сейчас",
      viewCart: "В корзину",
      continueShopping: "Продолжить покупки",
      subtotal: "Итого",
      checkout: "Оформить",
      checkoutTitle: "Данные доставки",
      checkoutSub: "Мы свяжемся с вами для подтверждения и оплаты.",
      backToCart: "Назад",
      checkoutSuccess: "Ваш заказ принят.",
      almostThere: "Почти у цели",
      toGo: "ещё",
      unlock80: "Заказы свыше €80 получают бутылку в подарок.",
      giftEyebrow: "Подарок Golden Elia",
      giftTitle: "Выберите ваш подарок — одна бутылка бесплатно.",
      giftIncluded: "Подарок",
    },
  },
};

export const LANGUAGES = [
  { code: "el", label: "ΕΛ", name: "Ελληνικά" },
  { code: "en", label: "EN", name: "English" },
  { code: "bg", label: "BG", name: "Български" },
  { code: "ru", label: "RU", name: "Русский" },
];

const LangCtx = createContext({ lang: "el", setLang: () => {}, t: () => "" });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("goldenelia-lang");
      if (saved && TRANSLATIONS[saved]) return saved;
    }
    return "el";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("goldenelia-lang", lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (TRANSLATIONS[l]) setLangState(l);
  };

  const t = (path) => {
    const parts = path.split(".");
    let v = TRANSLATIONS[lang];
    for (const p of parts) {
      if (v == null) return path;
      v = v[p];
    }
    return v ?? path;
  };

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
